import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManageCategory from "../components/ManageCategory";

const CategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Category' />

        {/* AddBlogLayer */}
        <ManageCategory />
      </MasterLayout>
    </>
  );
};

export default CategoryPage;
